import { Card, CardHeader } from '../../../components/Card.jsx'
import { Tile, PrevalenceList, MethodNote, fmtNum } from '../ui.jsx'

/**
 * National Chronic Disease Burden — lifetime prevalence of each
 * admin-configured chronic condition family (ICD-10 prefix groups),
 * counted as distinct affected patients across the whole population.
 */
export default function ChronicConditions({ data }) {
  const cc = data.chronic_conditions || {}
  const conditions = cc.conditions || []
  const denom = cc.denominator_patients || 0
  const topVisible = conditions.find((c) => !c.suppressed && c.count != null)

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader
          title="National chronic disease burden"
          subtitle="Lifetime prevalence — share of all registered patients carrying each chronic condition. Conditions and their ICD-10 prefixes are admin-configurable."
          right={
            <span className="text-[10px] uppercase tracking-wide border rounded-full px-2 py-0.5 bg-slate-100 text-slate-600 border-slate-300">
              lifetime
            </span>
          }
        />
        <MethodNote>
          Lifetime distinct-patient prevalence: a patient counts once per
          condition if any confirmed (non-differential) diagnosis matches that
          condition's admin-configured ICD-10 prefixes. Denominator is all
          registered patients; conditions below 5 patients are hidden (k=5 floor).
        </MethodNote>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          <Tile label="Patient denominator" value={fmtNum(denom)} colour="wantok" />
          <Tile label="Conditions tracked" value={fmtNum(conditions.length)} colour="sky" />
          {topVisible && (
            <Tile
              label="Most prevalent"
              value={topVisible.label}
              sublabel={`${fmtNum(topVisible.count)} patients`}
              colour="rose"
            />
          )}
        </div>
      </Card>

      <Card>
        <CardHeader
          title="Prevalence by condition"
          subtitle="Distinct affected patients (final/confirmed diagnoses only). Bars scale to the most prevalent condition."
        />
        <PrevalenceList
          items={conditions}
          colour="rose"
          denominatorLabel={`Percentages are of ${fmtNum(denom)} registered patients. Conditions below the k=5 privacy floor are withheld.`}
        />
      </Card>
    </div>
  )
}
